import dayjs from "dayjs";

const monthDate = (value) => (value ? dayjs(String(value).slice(0, 10)) : null);

/**
 * Describes membership seniority and vitalicio status from the API `lifetime` summary.
 * Returns message ids + values so the caller formats them with intl.
 */
export const memberSinceDetail = (lifetime, today = dayjs()) => {
  if (!lifetime) return null;
  const years = lifetime.years_as_member;
  const yearsPart = years != null ? { id: "gestion.accountFinance.memberYears", values: { years } } : null;

  if (lifetime.is_lifetime) {
    return {
      years: yearsPart,
      lifetime: {
        id: "gestion.accountFinance.lifetimeSince",
        values: { date: monthDate(lifetime.lifetime_from).format("MM/YYYY") },
      },
    };
  }

  const reachedOn = monthDate(lifetime.lifetime_from ?? lifetime.reached_on);
  if (lifetime.override === "revoked" || !reachedOn) {
    return { years: yearsPart, lifetime: lifetime.override === "revoked" ? { id: "gestion.accountFinance.lifetimeRevoked" } : null };
  }

  const months = Math.max(1, reachedOn.diff(today.startOf("month"), "month"));
  return {
    years: yearsPart,
    lifetime: {
      id: "gestion.accountFinance.lifetimeRemaining",
      values: { years: Math.floor(months / 12), months: months % 12, date: reachedOn.format("MM/YYYY") },
    },
  };
};

export const lifetimeToggleOverride = (lifetime) => (lifetime?.is_lifetime ? "revoked" : "granted");
